// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'babel-polyfill'
import ElementUI from 'element-ui'

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import { Button, Cell } from 'mint-ui'
import { Field } from 'mint-ui';
Vue.component(Field.name, Field);
Vue.component(Button.name, Button)
Vue.component(Cell.name, Cell)
Vue.use(MintUI)


import NProgress from 'nprogress'


import App from './App'
import store from './store'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/font-awesome-4.7.0/css/font-awesome.min.css'
import '@/assets/css/main.css'
import '@/assets/css/scrollbar.css'
import '@/assets/css/reset.css'
import 'nprogress/nprogress.css'
import 'animate.css'


import DropdownPlugin from './m/dropdown'
import NavbarPlugin from './m/navbar'
import ContextMenuPlugin from './m/context-menu'
import MButton from '@/m/button'
import MSwitch from '@/m/switch'
import MAlert from '@/m/alert'
import MCheckbox from '@/m/checkbox'
import MInput from '@/m/input'
import MLoading from '@/m/loading'
import Mkeyboard from '@/m/keyboard'
import MNumberkeyboard from '@/m/number-keyboard'
import MBox from '@/m/box'
import MBackTop from '@/m/back-top'
import MLoader from '@/m/loader'
import MContainer from '@/m/container'
import GlobalFunc from './utils/global/index'
import './assets/icon/iconfont.css' // icon
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

Vue.use(ElementUI)

Vue.use(DropdownPlugin)
Vue.use(NavbarPlugin)
Vue.use(ContextMenuPlugin)
Vue.use(MButton)
Vue.use(MSwitch)
Vue.use(MAlert)
Vue.use(MCheckbox)
Vue.use(MInput)
Vue.use(MLoading)
Vue.use(Mkeyboard)
Vue.use(MNumberkeyboard)
Vue.use(MBox)
Vue.use(MBackTop)
Vue.use(MLoader)
Vue.use(MContainer)
Vue.use(GlobalFunc)
Vue.use(mavonEditor)


router.afterEach(transition => {
  setTimeout(() => {
    NProgress.done()
  })
})


window.APP_INFO = process.env.APP_INFO

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.path === '/login') {
    sessionStorage.removeItem('user')
    localStorage.removeItem('user')
  }
  let user = JSON.parse(localStorage.getItem('user'))
  // if (to.path == '/mb/meeting/detail/2') {
  if (to.path == '/mbbb/meeting/detail/2') {
    next()
  } else if (!user && to.path !== '/login') {
    var next_path = to.path;
    next({ path: '/login?next=' + next_path })
  } else {
    next()
  }
})

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})

window.app = app




// WEBPACK FOOTER //
// ./src/main.js